import { render, staticRenderFns } from "./OrderManagementCopy.vue?vue&type=template&id=6df95001&scoped=true&"
import script from "./OrderManagementCopy.vue?vue&type=script&lang=js&"
export * from "./OrderManagementCopy.vue?vue&type=script&lang=js&"
import style0 from "./OrderManagementCopy.vue?vue&type=style&index=0&id=6df95001&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df95001",
  null
  
)

export default component.exports